class MtProductSpecsTabs {
  constructor(root) {
    this.root = root;
    this.tablist = root.querySelector('[data-mt-product-specs-tablist]');
    this.panels = root.querySelector('[data-mt-product-specs-panels]');
    this.groups = Array.from(root.querySelectorAll('.mt-product-specs__group'));
    this.idPrefix = root.dataset.sectionId || root.closest('[id]')?.id || 'product-specs';
    this.handleClick = this.handleClick.bind(this);
    this.handleKeydown = this.handleKeydown.bind(this);
  }

  init() {
    if (this.root.dataset.enableCategoryTabs !== 'true' || !this.tablist || !this.panels || this.groups.length < 2) {
      this.root.classList.add('mt-product-specs__tabs--fallback');
      return;
    }

    const categories = this.groups.map((group) => group.querySelector('.mt-product-specs__category'));
    if (categories.some((category) => !category || !category.textContent.trim())) {
      this.root.classList.add('mt-product-specs__tabs--fallback');
      return;
    }

    this.root.classList.add('mt-product-specs--tabs-ready');
    this.groups.forEach((group, index) => {
      const tabId = `${this.idPrefix}-tab-${index}`;
      const panelId = `${this.idPrefix}-panel-${index}`;
      const tab = document.createElement('button');

      tab.className = 'mt-product-specs__tab';
      tab.id = tabId;
      tab.type = 'button';
      tab.setAttribute('role', 'tab');
      tab.setAttribute('aria-controls', panelId);
      tab.setAttribute('aria-selected', index === 0 ? 'true' : 'false');
      tab.tabIndex = index === 0 ? 0 : -1;
      tab.textContent = categories[index].textContent.trim();
      this.tablist.append(tab);

      group.id = panelId;
      group.setAttribute('role', 'tabpanel');
      group.setAttribute('aria-labelledby', tabId);
      group.hidden = index !== 0;
    });

    this.tablist.addEventListener('click', this.handleClick);
    this.tablist.addEventListener('keydown', this.handleKeydown);
  }

  activate(index, shouldFocus = false) {
    const tabs = Array.from(this.tablist.querySelectorAll('[role="tab"]'));
    if (!tabs[index] || !this.groups[index]) return;

    tabs.forEach((tab, tabIndex) => {
      const active = tabIndex === index;
      tab.setAttribute('aria-selected', String(active));
      tab.tabIndex = active ? 0 : -1;
    });

    this.groups.forEach((group, groupIndex) => {
      group.hidden = groupIndex !== index;
    });

    if (shouldFocus) {
      tabs[index].focus();
    }
  }

  handleClick(event) {
    const tab = event.target.closest('[role="tab"]');
    if (!tab || !this.tablist.contains(tab)) return;
    this.activate(Array.from(this.tablist.children).indexOf(tab));
  }

  handleKeydown(event) {
    const tab = event.target.closest('[role="tab"]');
    if (!tab || !this.tablist.contains(tab)) return;

    const tabs = Array.from(this.tablist.querySelectorAll('[role="tab"]'));
    const index = tabs.indexOf(tab);
    let nextIndex = null;

    if (event.key === 'ArrowRight' || event.key === 'ArrowDown') {
      nextIndex = (index + 1) % tabs.length;
    }
    if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') {
      nextIndex = (index - 1 + tabs.length) % tabs.length;
    }
    if (event.key === 'Home') nextIndex = 0;
    if (event.key === 'End') nextIndex = tabs.length - 1;

    if (nextIndex !== null) {
      event.preventDefault();
      this.activate(nextIndex, true);
    }
  }
}

function initMtProductSpecsTabs() {
  document.querySelectorAll('[data-mt-product-specs-tabs]').forEach((root) => {
    if (root.mtProductSpecsTabs) return;
    root.mtProductSpecsTabs = new MtProductSpecsTabs(root);
    root.mtProductSpecsTabs.init();
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initMtProductSpecsTabs, { once: true });
} else {
  initMtProductSpecsTabs();
}

document.addEventListener('shopify:section:load', initMtProductSpecsTabs);
